<template>
  <div class="head">
    <div class="head-inner">
      <!-- 左侧 Logo：直接展示图片，不加白卡 -->
      <div class="logo" @click="goHome">
        <img :src="'https://www.jqnmzy.cn' + this.centerlog" alt="巨琪诺美制药" />
      </div>

      <!-- 菜单：左侧排布 -->
      <ul class="menu">
        <li
          v-for="(item, index) in list"
          :key="index"
          @click="jump(item)"
          :class="['menu-item', { active: curIndex === index }]"
        >
          <span class="menu-text">{{ item.name }}</span>
        </li>
      </ul>

      <!-- 移动端汉堡 -->
      <div
        class="hamburger"
        @click="jumps"
        :class="quxiao ? '' : 'open'"
      >
        <span></span>
        <span></span>
        <span></span>
      </div>
    </div>

    <el-drawer
      title="菜单"
      :visible.sync="drawer"
      :direction="direction"
      size="50%"
      :modal="!isMobile"
      :before-close="handleClose"
    >
      <ul class="iphone-menu">
        <li
          v-for="(item, index) in list"
          :key="index"
          @click="jumpiphone(item)"
          class="iphone-item"
        >{{ item.name }}</li>
      </ul>
    </el-drawer>
  </div>
</template>

<script>
import { getlogo } from '@/api/index';
export default {
  data() {
    return {
      list: [
        { name: '首页', url: 'home', id: 1 },
        { name: '关于我们', id: 1, url: 'Aboutus' },
        { name: '产品展示', id: 1, url: 'Medicalsupplies' },
        { name: '新闻中心', id: 1, url: 'news' },
        { name: '在线反馈', id: 1, url: 'consultation' },
        { name: '联系我们', id: 1, url: 'contactus' }
      ],
      styleshow: true,
      drawer: false,
      quxiao: true,
      direction: 'rtl',
      centerlog: '',
      curIndex: -1,
      isMobile: false
    };
  },
  created() {
    this.getinformation();
    this.syncActive();
    this.checkMobile();
    window.addEventListener('resize', this.checkMobile);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkMobile);
  },
  watch: {
    '$route.name'() {
      this.syncActive();
    }
  },
  methods: {
    checkMobile() {
      this.isMobile = window.innerWidth <= 992;
    },
    syncActive() {
      const name = this.$route.name;
      const idx = this.list.findIndex((it) => it.url === name);
      this.curIndex = idx;
    },
    goHome() {
      this.$router.push({ name: 'home' });
    },
    jump(item) {
      this.$router.push({ name: item.url });
    },
    getinformation() {
      getlogo().then((res) => {
        if (res && res.data && res.data.rows && res.data.rows[0]) {
          this.centerlog = res.data.rows[0].logo_image;
        }
      });
    },
    jumpiphone(item) {
      this.handleClose();
      this.$router.push({ name: item.url });
    },
    jumps() {
      this.quxiao = !this.quxiao;
      this.drawer = true;
    },
    handleClose() {
      this.quxiao = true;
      this.drawer = false;
    }
  }
};
</script>

<style scoped>
/* ===== 顶部导航：白色背景，参考华森制药样式 ===== */
.head {
  position: sticky;
  top: 0;
  z-index: 1000;
  width: 100%;
  height: 90px;
  background-color: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  box-sizing: border-box;
}

.head-inner {
  position: relative;
  width: 100%;
  max-width: 1200px;
  height: 90px;
  margin: 0 auto;
  padding: 0 40px;
  box-sizing: border-box;
}

/* Logo：直接展示，无白卡 */
.logo {
  position: absolute;
  left: 40px;
  top: 50%;
  transform: translateY(-50%);
  height: 64px;
  display: flex;
  align-items: center;
  cursor: pointer;
  z-index: 2;
  transition: transform 0.25s ease;
}

.logo:hover {
  transform: translateY(-50%) scale(1.02);
}

.logo img {
  display: block;
  height: 64px;
  max-width: 240px;
  object-fit: contain;
}

/* 菜单：从 Logo 右侧排布 */
.menu {
  position: absolute;
  left: 320px;
  top: 0;
  height: 90px;
  display: flex;
  align-items: center;
  list-style: none;
  margin: 0;
  padding: 0;
  z-index: 1;
}

.menu-item {
  height: 90px;
  padding: 0 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  color: #333;
  white-space: nowrap;
  cursor: pointer;
  position: relative;
  transition: color 0.25s ease;
}

.menu-text {
  position: relative;
  padding-bottom: 6px;
}

/* 非 active 状态下文字下方蓝色下划线（隐藏，仅 active 显示） */
.menu-text::after {
  content: '';
  position: absolute;
  left: 50%;
  bottom: 0;
  width: 0;
  height: 2px;
  background-color: #1890ff;
  transition: width 0.3s ease, left 0.3s ease;
}

/* hover：浅蓝渐变背景 + 蓝字 + 蓝下划线 */
.menu-item:hover {
  color: #1890ff;
  background: linear-gradient(180deg, rgba(24, 144, 255, 0.08) 0%, rgba(24, 144, 255, 0.18) 100%);
}

.menu-item:hover .menu-text::after {
  left: 20%;
  width: 60%;
}

/* active：更明显的蓝渐变 + 蓝字 + 下划线全展开 */
.menu-item.active {
  color: #1890ff;
  background: linear-gradient(180deg, rgba(24, 144, 255, 0.15) 0%, rgba(24, 144, 255, 0.32) 100%);
}

.menu-item.active .menu-text::after {
  left: 0;
  width: 100%;
}

/* 移动端汉堡：深色横线 */
.hamburger {
  display: none;
  position: absolute;
  right: 16px;
  top: 50%;
  transform: translateY(-50%);
  width: 44px;
  height: 41px;
  cursor: pointer;
  z-index: 2;
}

.hamburger span {
  display: block;
  width: 24px;
  height: 2px;
  left: 10px;
  background-color: #333;
  position: absolute;
  transition: all 0.25s linear;
}

.hamburger span:nth-child(1) { top: 10px; }
.hamburger span:nth-child(2) { top: 18px; }
.hamburger span:nth-child(3) { top: 26px; }

.hamburger.open span:nth-child(2) { opacity: 0; }
.hamburger.open span:nth-child(1) { top: 20px; transform: rotate(45deg); background-color: #333; }
.hamburger.open span:nth-child(3) { top: 20px; transform: rotate(-45deg); background-color: #333; }

/* 抽屉菜单：白底深字 */
::v-deep .el-drawer__header {
  color: #333 !important;
  margin-bottom: 0;
}
::v-deep .el-drawer.rtl {
  background-color: #fff;
}

/* 响应式 */
@media screen and (max-width: 992px) {
  .head { height: 64px; }
  .head-inner { height: 64px; padding: 0 16px; }
  .logo { left: 16px; height: 44px; }
  .logo img { height: 44px; }
  .menu { display: none; }
  .hamburger { display: block; }

  .iphone-item {
    height: 44px;
    line-height: 44px;
    padding: 0 16px;
    font-size: 15px;
    text-align: left;
    padding-left: 24px;
  }
}
</style>